import { Stack, StackProps } from '@mui/material';

type Props = {
  value: string;
  sx?: StackProps['sx'];
};

export const ActivePoint = ({ value, sx }: Props) => (
  <Stack
    sx={{
      alignItems: 'center',
      justifyContent: 'center',
      width: 10,
      height: 10,
      minWidth: 10,
      borderRadius: '100%',
      position: 'relative',
      backgroundColor: value ? 'success.main' : 'error.main',

      ...(value
        ? {
            ':before': {
              content: '""',
              position: 'absolute',
              width: '100%',
              height: '100%',
              borderRadius: '100%',
              backgroundColor: value ? 'success.main' : 'error.main',
              animation: 'ping 1.5s cubic-bezier(0, 0, 0.2, 1) infinite',
              opacity: 0.4,
            },
            '@keyframes ping': {
              '75%, 100%': {
                transform: 'scale(2)',
                opacity: 0,
              },
            },
          }
        : {}),
    }}
  />
);

export default ActivePoint;
